import { APIURL, LANG } from '../../constants';
import { plotDistances, parseFileName } from '../../tools/';
import feedBackTools from '../../tools/feedback';
import axios from 'axios';

export default {
  namespaced: true,

  state: {
    editMode: false,
    routes: [],
    zoom: 13,
    center: {
      lat: 66.5,
      lng: 25.7
    },
    // set undefined on delete, if route _id matches one of the
    // deleted ones
    route: undefined,
    routeLayerGroupVisible: true,

    matchingFocusPoints: {},
    showMatchingFocusPointsDialog: false,
    search: '',
    markers: [],
    // set undefined on delete if _id matches to any of the deleted
    selectedMarker: undefined,
    // set undefined on delete if _id matches to any of the deleted
    selectedLeafletMarker: undefined,
    // set to default after insert // TODO: check that it works
    newRoute: {
      displayName: '',
      createFinishCheckpointAutomatically: true,
      routegroup: undefined
    },
    hasFinish: false,
    editableFeature: undefined,
    oldNames: {},
    isFething: false,
    confirmRouteDelete: false,
    movedMarkers: {},
    updateLocation: false,

    //routeGroups: [],
    editRouteGroup: false,
    editRouteDescription: false,
    editableDescription: {},
    routeLength: 0,
    isUpdatingRouteGroup: false,
    editRouteView: 1,
    calculateLengthAutomatically: false,
    feedback: []
  },

  actions: {
    updateRoutePosition(context, payload) {
      return axios
        .put(
          `${APIURL}trackingroutes/${context.state.route._id}/position/`,
          payload
        )
        .then(updateRoutePositionRes => {
          if (updateRoutePositionRes.status === 200) {
            return Promise.resolve(true);
          } else {
            return Promise.resolve(false);
          }
        })
        .catch(() => {
          return Promise.reject();
        });
    },

    restore(context, payload) {
      let url = APIURL + 'trackingroutes/' + payload._id + '/restore';
      //console.log("restore", url)
      return axios.patch(url);
      /*.then((res) => {
                context.dispatch('setUpdatedRoute', res.data);
                window.vm.$emit('routeUpdated')
               // window.vm.$emit('routeAdded')
                
                console.log(res.data)
            }).catch((err) => {
                console.log(err)
            }) */

      //
    },

    feedback(context, payload) {
      context.dispatch('setIsFetching', true);
      axios
        .get(`${APIURL}trackingroutes/${payload}/feedback`)
        .then(res => {
          //console.log("######### feedback", res.data)
          context.dispatch('setIsFetching', false);
          context.commit('setFeedback', res.data);
        })
        .catch(err => {
          console.log('######## feedback', err);
          context.dispatch('setIsFetching', false);
        });
    },

    copyAccessible(context) {
      return axios.post(
        `${APIURL}trackingroutes/accessible/${context.state.route._id}`
      );
    },

    calculateBounds(context) {
      let features = context.state.route.features.map(f => {
        return {
          type: 'Feature',
          geometry: f.geometry
        };
      });

      let route = {
        type: 'FeatureCollection',
        features: features
      };

      try {
        let geoJSON = window.L.geoJSON(route);
        let geoJSONBounds = geoJSON.getBounds();
        //console.error("######## calculateBounds", geoJSONBounds)

        let bounds = Object.keys(geoJSONBounds).map(compassPoint => {
          let coordinates = [
            geoJSONBounds[compassPoint].lng,
            geoJSONBounds[compassPoint].lat
          ];

          return {
            type: 'Point',
            coordinates: coordinates
          };
        });

        axios
          .put(
            APIURL + 'trackingroutes/updateBounds/' + context.state.route._id,
            { bounds: bounds }
          )
          .then(() => {})
          .catch(() => {
            //console.log("#updateErr", updateErr);
          });
      } catch (err) {
        //console.error(err)
      }
    },

    calculateLength(context) {
      let routeLength = 0;
      let lines = context.rootGetters['lines/lines'];
      lines.forEach(l => {
        let line = new window.L.polyline(l.points);
        line._latlngs.forEach((_ll, _lli) => {
          if (_lli > 0) {
            routeLength += line._latlngs[_lli].distanceTo(
              line._latlngs[_lli - 1]
            );
          }
        });
      });
      //console.error("########calculateLength", routeLength)
      context.dispatch('setRouteLength', routeLength);
      context.dispatch('updateRouteLength');
    },

    setCalculateLengthAutomatically(context, payload) {
      context.commit('setCalculateLengthAutomatically', payload);
      if (payload === true) {
        context.dispatch('calculateLength');
      }
    },

    cancelUpdate(context) {
      context.commit('cancelUpdate');
    },

    setUpdatedRoute(context, payload) {
      let updatedRoute = context.state.routes.findIndex(r => {
        return r._id == payload._id;
      });

      //console.error("###### updatedRoute", payload)

      if (updatedRoute > -1) {
        context.dispatch('route', payload);

        context.commit('setUpdatedRoute', { route: payload, i: updatedRoute });
      }
    },

    updateRouteLength(context) {
      axios
        .put(
          APIURL +
            'trackingroutes/updateRouteLength/' +
            context.state.route._id,
          { routeLength: context.state.route.length }
        )
        .then(() => {
          this.$store.dispatch('status/updateResources', 'routedata', {
            root: true
          });
        })
        .catch(() => {
          //console.log("err", err)
        });
    },

    // TODO: update length automatically
    setRouteLength(context, payload) {
      if (context.state.calculateLengthAutomatically) {
        payload = payload / 1000;
        payload = Math.round(payload * 10) / 10;
      }

      context.commit('setRouteLength', payload);
      if (context.state.calculateLengthAutomatically) {
        context.dispatch('updateRouteLength');
      }
    },

    setCheckpoint(context, payload) {
      let route = context.state.route;

      let found = route.features.findIndex(f => {
        return f._id === payload._id;
      });

      if (found > -1) {
        context.commit('setCheckpoint', { found: found, checkpoint: payload });
      } /*else {
                console.log("hep::setCheckpoint", found)
            }*/
    },

    lastLocation(context) {
      let route = context.state.route;
      if (typeof route !== 'undefined' && route.features.length >= 2) {
        let length = route.features.length;

        let last = route.features[length - 1];
        if (last.properties.isFinish === true) {
          last = route.features[length - 2];
        }

        return Promise.resolve(last);
      }

      return Promise.reject({});
    },

    updateDescription(context, payload) {
      payload.files = payload.files.filter(f => {
        return f.remove !== true;
      });

      payload.files.forEach(f => {
        if (typeof f.path !== 'undefined') {
          let lio = f.path.lastIndexOf('/');
          let p = f.path.substring(lio);

          if (f.type !== 'YoutubeVideo') {
            p = parseFileName(p);

            f.path = 'images/' + context.state.route.name + '/' + p;
            f.oldPath = 'images/' + context.state.route.name + '/' + p;
          } else {
            lio = f.path.lastIndexOf('v=') + 2;
            p = f.path.substring(lio);

            f.path = p;
          }
        }
      });

      axios
        .put(
          APIURL +
            'trackingroutes/updateDescription/' +
            context.state.route._id,
          payload
        )
        .then(res => {
          context.commit('setEditRouteDescription', false);
          context.dispatch('setUpdatedRoute', res.data);
          window.vm.$emit('routeUpdated');
        })
        .catch(() => {
          //console.log("########err", err)
        });
    },

    updateRouteGroup(context, payload) {
      return axios.put(
        APIURL + 'trackingroutes/updateRouteGroup/' + context.state.route._id,
        { routegroup: payload }
      );
    },

    detachFromRouteGroup(context) {
      return axios.put(
        APIURL + 'trackingroutes/detach/' + context.state.route._id
      );
    },

    /*checkIfCanBeDetached(context, payload) {
            let cbd = false;
            let routes = context.state.routes;
            if (routes.length > 1) {
                let others = routes.filter((r) => {
                    return r._id !== payload._id;
                });

                let matchingRouteGroup = others.find((o) => {
                    return o.routegroup === payload.routegroup
                })

                if (matchingRouteGroup) {
                    cbd = true;
                }
            }

            return Promise.resolve(cbd);

        },

        detachFromRouteGroup(context) {
            return axios.put(APIURL + 'trackingroutes/detach/' + context.state.route._id);

        },*/

    mapMarkersToLeafletMarkers(context, payload) {
      let markerIds = Object.keys(payload).map(id => {
        return id;
      });
      let markers = [];
      markerIds.forEach(id => {
        let marker = context.state.markers.find(m => {
          return id == m._id;
        });

        if (marker) {
          marker.leafletid = payload[marker._id];
          markers.push(marker);
        }
      });

      //console.log("mapMarkersToLeafletMarkers", markers)

      context.commit('mapMarkersToLeafletMarkers', markers);
    },

    setSelectedRouteGroup(context, payload) {
      context.commit('setIsUpdatingRouteGroup', true);

      let validRouteGroup = context.state.routes.find(r => {
        return r.routegroup == payload;
      });

      if (validRouteGroup) {
        //context.commit('setSelectedRouteGroup', validRouteGroup);

        context
          .dispatch('updateRouteGroup', validRouteGroup.routegroupDisplayName)
          .then(res => {
            //console.log("################ setSelectedRouteGroup")

            context.dispatch('setUpdatedRoute', res.data);
            window.vm.$emit('routeAdded');
            context.commit('setIsUpdatingRouteGroup', false);
          });
      } else {
        context.commit('flushSelectedRouteGroup');
      }
    },

    setSelectedNewRouteRouteGroup(context, payload) {
      let i = context.state.routeGroups.findIndex(rg => {
        return rg.value == payload;
      });

      if (i > -1) {
        context.commit('setSelectedNewRouteRouteGroup', i);
      } else {
        context.commit('flushSelectedNewRouteRouteGroup');
      }
    },

    setUpdateLocation(context, payload) {
      context.commit('setUpdateLocation', payload);
    },

    // updates markers that have been moved on the map
    updateMovedMarkers(context, payload) {
      let markers = [];

      let layerIds = Object.keys(payload._layers).map(id => {
        return id;
      });

      layerIds.forEach(id => {
        let marker = context.state.markers.find(m => {
          return m.leafletid == id;
        });

        if (marker) {
          context.state.matchingFocusPoints[marker._id].forEach(m => {
            m.newPosition = payload._layers[id]._latlng;
            let latLngDifference = {
              lat: m.newPosition.lat - marker.position.lat,
              lng: m.newPosition.lng - marker.position.lng
            };

            (m.latLngDifference = latLngDifference), markers.push(m);
          });
        } /*else {
                    console.log("marker not found")
                }*/
      });

      if (markers.length > 0) {
        return axios.put(APIURL + 'trackingroutes/updatePositions', markers);
      }

      return Promise.reject(undefined);
    },

    // keeps track of the moved route markers

    setMovedMarker(context, payload) {
      let found = context.state.markers.find(m => {
        return m.leafletid == payload.id;
      });

      if (found) {
        context.commit('setMovedMarker', payload);
      }
    },

    /*calculateBearing(context)
        {
            context.state.markers.forEach((m) => {

                let latRoute = m.focusPoint.coordinates[1];
                let lngRoute = m.focusPoint.coordinates[0];
                let routeLatLng = new L.LatLng(
                    latRoute, lngRoute
                )




                m.features.forEach((f) => {

                    let latF = f.geometry.coordinates[1];
                    let lngF = f.geometry.coordinates[0];

                    let checkPointLatLng = new L.LatLng(
                        latF, lngF
                    )
                    //console.log(checkPointLatLng)
                    //routeLatLng.bearingTo(checkPointLatLng)




                })
            })

        }, */

    // this is triggered on delestart,
    // moves undeletetable markers to another layer temporarily
    disableMarkerDelete(context) {
      let leafletIds = [];
      Object.keys(context.state.matchingFocusPoints).forEach(markerId => {
        let routes = context.state.matchingFocusPoints[markerId];

        if (routes.length > 1) {
          routes.forEach(r => {
            leafletIds.push(r.leafletid);
          });
        }
      });

      leafletIds = leafletIds.filter(id => {
        return typeof id !== 'undefined';
      });

      return Promise.resolve(leafletIds);
    },

    setIsFetching(context, payload) {
      context.commit('setIsFetching', payload);
    },

    // When marker is created or moved on the map,
    // we need to calculate the closest other marker
    // to see if the new marker needs to be added to an existing routegroup
    closestMarker(context, payload) {
      let lat = payload.lat;
      let lng = payload.lng;
      let distances = [];
      let closest = undefined;

      if (typeof context.state.route !== 'undefined') {
        distances = context.state.route.features.map(f => {
          return plotDistances(
            f.geometry.coordinates[1],
            f.geometry.coordinates[0],
            lat,
            lng,
            f
          );
        });

        distances.forEach(d => {
          if (typeof closest === 'undefined' || d.distance < closest.distance) {
            //console.log("#########d", d.distance)
            closest = d;
          }
        });
      }

      if (typeof closest === 'undefined' || closest.distance > 50) {
        return Promise.reject({ valid: false, closest: closest });
      }

      return Promise.resolve({ valid: true, closest: closest });
    },

    // used to change checkpoint order in editRoute form
    sortFeatures(context, payload) {
      context.commit('sortFeatures', payload);
    },

    update(context) {
      return axios
        .put(APIURL + 'trackingroutes/' + context.state.route._id, {
          displayName: context.state.route.displayName
        })
        .then(() => {
          context.commit('update', context.state.route.displayName);
          return Promise.resolve(context.state.route);
        })
        .catch(err => {
          return Promise.reject(err);
        });
      /*.then((res) => {
                    /*context.dispatch('setUpdatedRoute', res.data)
                    //window.vm.$emit('routeUpdated')
                    win*/

      /* window.vm.$emit('routeNameUpdated');
                })
                .catch((routeNameUpdateErr) => {

                    window.vm.$emit('routeNameUpdated', routeNameUpdateErr);
                })*/
    },

    setName(context, payload) {
      context.commit('setName', payload);
      //context.dispatch('checkIfDirty')
      context.commit('setIsDirty', true);
    },

    setDisabled(context, payload) {
      axios
        .put(
          APIURL + 'trackingroutes/updateDisabled/' + context.state.route._id,
          { disabled: payload }
        )
        .then(res => {
          context.commit('setDisabled', res.data.disabled);
          context.dispatch('status/updateResources', 'routedata', {
            root: true
          });
        })
        .catch(() => {
          //console.log(err)
        });

      //context.commit('setIsDirty', true);
    },

    setAccessible(context, payload) {
      axios
        .put(
          APIURL + 'trackingroutes/updateAccessible/' + context.state.route._id,
          { accessible: payload }
        )
        .then(res => {
          context.commit('setAccessible', res.data.accessible);
          context.dispatch('status/updateResources', 'routedata', {
            root: true
          });
        })
        .catch(() => {
          //console.error("########## err", err)
        });

      //context.commit('setIsDirty', true);
    },

    // stores checkpoint names to store,
    // so that they can be marked as dirty if the checkpoint name is changed
    // called in setRoute
    setOldNames(context, payload) {
      let oldNames = {};
      payload.features.forEach(f => {
        oldNames[f._id] = f.properties.name;
      });

      context.commit('setOldNames', oldNames);
    },

    // if cancel button is clicked in editRoute form
    cancelFeatureEdit(context) {
      context.commit('cleanEditableFeature');
      context.commit('flushFeatureEditable');
      //context.dispatch('checkIfDirty')
      //context.commit('setFeatureEditable', undefined)
    },

    // if ok button is clicked in editRoute form
    acceptFeatureEdit(context) {
      axios
        .put(
          APIURL + 'trackinglocations/' + context.state.editableFeature._id,
          context.state.editableFeature
        )
        .then(res => {
          context.commit('flushFeatureEditable');
          context.commit('setEditedFeature', res.data);
          window.vm.$emit('routeUpdated');
        })
        .catch(() => {
          //console.log("err", err);
        });
    },

    // updates edited feature name to state in editRoute form
    setEditableFeatureName(context, payload) {
      context.commit('setEditableFeatureName', payload);
      //context.dispatch('checkIfDirty');
    },

    // used to check if route is dirty
    // is true if any checkpoint name is changed
    // or route name is changed
    /*checkIfDirty(context) {

            let isDirty = false;
            let firstDirtyFeature = context.state.route.features.find((f) => {

                return f.isDirty
            })


            if (firstDirtyFeature
                || context.state.route.displayName != context.state.route.oldName) {
                isDirty = true
            }


            //context.commit('setIsDirty', isDirty);

        },*/

    // used in editRoute form
    // show red info icon with "there's no finish checkpoint" text if finish checkpoint doesnt exist
    /*checkIfHasFinish(context, payload)
        {
            let hasFinish = false;
            let found = payload.features.find((f) => {
                return f.properties.isFinish === true;
            })

            if(found) { hasFinish = true; }
            context.commit('setHasFinish', hasFinish)


        },*/

    // toggles createfinishcheckpointautomatically
    // is called in NewRoute form
    setCreateFinishCheckpointAutomatically(context, payload) {
      context.commit('setCreateFinishCheckpointAutomatically', payload);
    },

    // TODO: deprecated needs testing
    findMarkerByLeafletId(context) {
      let marker = context.state.markers.find(m => {
        return context.state.newRoute.marker._leafletid == m.leafletid;
      });

      return Promise.resolve(marker);
    },

    destroy(context, payload) {
      //console.log("######### destroy mit vit")
      let route = context.state.route;
      let url = APIURL + 'trackingroutes/bulkDestroy?deleteLines';
      if (payload === true) {
        url += '&hardDelete=1';
      }

      return axios.post(url, { markers: [route] });
    },

    // is called when leaflet delete is saved in routes/Index.vue
    bulkDestroy(context, payload) {
      let layerids = [];

      // find markers layerids of the deleted markers

      let markers = Object.keys(payload._layers).map(layerid => {
        layerids.push(layerid);

        let marker = context.state.markers.find(m => {
          return m.leafletid == parseInt(layerid);
        });

        return marker;
      });

      if (
        typeof context.state.newRoute !== 'undefined' &&
        typeof context.state.newRoute.marker !== 'undefined'
      ) {
        let found = layerids.find(lid => {
          return lid == context.state.newRoute.marker._leaflet_id;
        });

        if (found) {
          context.dispatch('flushNewRoute');
        }
      }

      // get rid of undefined values
      markers = markers.filter(m => {
        return typeof m !== 'undefined';
      });

      if (markers.length > 0) {
        return axios.post(APIURL + 'trackingroutes/bulkDestroy?deleteLines', {
          markers: markers
        });
      }

      return Promise.resolve(undefined);
    },

    // initializes newRoute object in state
    // after newRoute is added successfully
    flushNewRoute(context) {
      if (context.rootGetters['drawer/visibility']) {
        context.dispatch('drawer/toggleVisibility', false, { root: true });
      }
      context.commit('flushNewRoute');
    },

    // sets selectedMarker to undefined after bulkDestroy if selectedMarker is
    // one of the deleted routes
    // is called in routes/Index.vue
    flushSelectedMarker(context) {
      if (typeof context.state.selectedMarker !== 'undefined') {
        let route = context.state.routes.find(r => {
          return r._id == context.state.selectedMarker._id;
        });

        if (route) {
          context.commit('setSelectedMarker', undefined);
        }
      }
    },

    // highLights the checkpoint name in EditRoute.vue
    // when marker on the map is hovered
    setHighLighted(context, payload) {
      context.commit('flushHighLighted');
      let i = context.state.route.features.findIndex(f => {
        return f._id == payload;
      });

      if (i > -1) {
        context.commit('setHighLighted', i);
      }
    },

    // triggers if delete is cancelled in EditRoute.vue
    cancelDeleteCheckpoint(context) {
      context.commit('flushConfirmDelete');
    },

    // shows delete route confirmation in EditRoute.vue
    setConfirmRouteDelete(context, payload) {
      context.commit('setConfirmRouteDelete', payload);
    },

    // shows confirm delete text in EditRoute.vue when deleting
    setConfirmDelete(context, payload) {
      context.commit('flushConfirmDelete');
      let i = context.state.route.features.findIndex(f => {
        return f._id == payload._id;
      });

      if (i > -1) {
        context.commit('setConfirmDelete', i);
      }
    },

    // triggers when chekpoint name is double clicked in EditRoute.vue
    setFeatureEditable(context, payload) {
      context.commit('flushFeatureEditable');
      let i = context.state.route.features.findIndex(f => {
        return f._id == payload;
      });

      if (i > -1) {
        context.commit('setFeatureEditable', { id: payload, i: i });
      }
    },

    // same as flushSelectedMarker but for the leaflet map marker
    flushSelectedLeafletMarker(context) {
      if (typeof context.state.selectedLeafletMarker !== 'undefined') {
        context.commit('setSelectedLeafletMarker', undefined);
      }
    },

    flushRoute(context) {
      if (typeof context.state.route !== 'undefined') {
        let route = context.state.routes.find(r => {
          return r._id == context.state.route._id;
        });
        if (route) {
          context.dispatch('route', undefined);
        }
      }
    },

    setNewRouteDisplayName(context, payload) {
      context.commit('setNewRouteDisplayName', payload);
    },

    setNewRouteMarker(context, payload) {
      context.commit('setNewRouteMarker', payload);
    },

    // when leaflet markers are created, each is assigned an unique id
    // this action maps that unique id to the route

    /*setMarkerLeafletId(context, payload)
        {

            let i = context.state.markers.findIndex((m) => {

                return m._id == payload.id;
            })

            if(i > -1)
            {
                let marker = context.state.markers[i];
                context.commit('setMarkerLeafletId', {
                    i: i, leafletid: payload.leafletid
                });
            }
        }, */

    store(context) {
      //console.log(context.state.newRoute)
      let lat = context.state.newRoute.marker._latlng.lat;
      let lng = context.state.newRoute.marker._latlng.lng;
      let displayName = context.state.newRoute.displayName;
      let routegroup = context.state.newRoute.routegroup;

      return axios.post(APIURL + 'trackingroutes', {
        displayName: displayName,
        lat: lat,
        lng: lng,
        routegroup: routegroup,
        lang: window.localStorage.getItem(LANG)
      });
    },

    index(context) {
      context.commit('setIsFetching', true);
      let onlyHidden = window.localStorage.getItem('onlyHidden');
      //console.log(onlyHidden)

      let url = `${APIURL}trackingroutes`;

      if (onlyHidden == 1) {
        url += '?showRemoved=1';
      }
      //console.log("index", url)
      return axios.get(url);
    },

    setPreviousVisible(context) {
      let indexes = [];
      context.state.markers.forEach((m, i) => {
        if (!m.visible) {
          indexes.push(i);
        }
      });

      context.commit('setVisible', { indexes: indexes, visible: true });
    },

    setSelectedMarker(context, payload) {
      context.commit('setSelectedMarker', payload);
    },

    setSelectedLeafletMarker(context, payload) {
      context.commit('setSelectedLeafletMarker', payload);
    },

    search(context, payload) {
      context.commit('search', payload);
    },

    // checks if more than one route have exactly the same focuspoint
    matchingFocusPoints(context, payload) {
      let routes = [];
      /*let distances = context.state.routes.map((r) => {
                return plotDistances(r, payload.m)

            });
            let routes = [];

            distances.forEach((d) => {
                if(d.distance == 0)
                {
                    routes.push(d.r)
                }
            })*/

      context.state.routes.forEach(r => {
        if (r.routegroup == payload.m.routegroup) {
          routes.push(r);
        }
      });

      return Promise.resolve({ routes: routes, m: payload.m });
      //context.commit('matchingFocusPoints', {routes: routes, marker: payload.marker})
    },

    setZoom(context, payload) {
      context.commit('setZoom', payload);
    },

    setCenter(context, payload) {
      context.commit('setCenter', payload);
    },

    // toggles the leaflet map route marker layer visibility
    setRouteLayerGroupVisible(context, payload) {
      context.commit('setRouteLayerGroupVisible', payload);
    },

    route(context, payload) {
      if (typeof payload !== 'undefined') {
        payload.isDirty = false;
        payload.oldName = payload.displayName;
        payload.canBeDetached = false;
      }

      context.commit('route', payload);
    },

    // if more than one route have the same focuspoint coordinates,
    // this methods shows the dialog with the matching focuspoints
    setShowMatchingFocusPointsDialog(context, payload) {
      context.commit('setShowMatchingFocusPointsDialog', payload);
    },

    setVisible(context, payload) {
      let indexes = [];
      context.state.markers.forEach((m, i) => {
        if (m.routegroup == context.state.selectedMarker.routegroup) {
          indexes.push(i);
        }
      });

      context.commit('setVisible', { indexes: indexes, visible: payload });
    },
    // triggered when creating new route and start checkpoint for that
    addLocation(context, payload) {
      //console.log("################# addLocation ###########", payload)
      axios
        .put(APIURL + 'trackingroutes/addLocation/' + payload.routeId, payload)
        .then(res => {
          //console.log("################### addLocation res ########", res.data)
          // replaces the existing route data with the the new one (including start (and optionally finish) checkpoint data)

          let i = context.state.routes.findIndex(r => {
            return r._id == res.data._id;
          });

          //console.log("############# i", i)

          if (i > -1) {
            //console.log("############### heplkdfsjdsflkdfsjdfls #######")
            context.commit('replace', { i: i, route: res.data });
            if (payload.emitRouteAdded) {
              //console.error("########### emitRouteAdded #######")
              window.vm.$emit('routeAdded');
            }
          }
        })
        .catch(() => {
          //console.error("addLocation err", err);
        });
    },

    addBlankLocation(context, payload) {
      //console.log("############# addBlankLocation ###########", payload)
      return axios.put(
        APIURL + 'trackingroutes/addLocation/' + payload.routeId,
        payload
      );
    }
  },

  mutations: {
    update(state, payload) {
      state.route = { ...state.route, displayName: payload };
      let markers = state.markers;
      markers = markers.map(m => {
        if (m._id != state.route._id) {
          return m;
        } else {
          m = { ...m, displayName: payload };
          console.log(m);
          return m;
        }
      });
      console.log(markers);
      state.markers = [...markers];
    },

    updateMarkerPos(state, payload) {
      let markers = state.markers;

      let f = markers.findIndex(m => {
        return m._id == payload._id;
      });

      if (f > -1) {
        markers[f] = payload;
        state.markers = markers.slice();
      }
    },

    updateRoutePos(state, payload) {
      let routes = state.routes;

      let r = routes.findIndex(r => {
        return r._id == payload._id;
      });

      if (r > -1) {
        routes[r] = payload;
        state.routes = routes.slice();
      }
    },

    setEditMode(state, payload) {
      state.editMode = payload;
    },

    newRouteSetLat(state, payload) {
      state.newRoute.marker._latlng.lat = payload;
    },

    newRouteSetLng(state, payload) {
      state.newRoute.marker._latlng.lng = payload;
    },

    setFeedback(state, payload) {
      state.feedback = feedBackTools.parseToCurrentLanguage(payload).slice();
    },

    setCalculateLengthAutomatically(state, payload) {
      state.calculateLengthAutomatically = payload;
    },

    setEditRouteView(state, payload) {
      state.editRouteView = payload;
    },

    cancelUpdate(state) {
      let route = state.route;
      route.isDirty = false;
      route.displayName = route.oldName;

      state.route = undefined;
      state.route = route;
    },

    setIsUpdatingRouteGroup(state, payload) {
      state.isUpdatingRouteGroup = payload;
    },

    setUpdatedRoute(state, payload) {
      let routes = state.routes;
      routes[payload.i] = payload.route;

      //console.error("###setUpdatedRoute", payload.route)

      //state.routes = []
      state.routes = routes.slice();
      //console.log("###setUpdatedRoute:: state.routes", state.routes)
    },

    setEditedFeature(state, payload) {
      let route = state.route;

      let i = route.features.findIndex(f => {
        return f._id === payload._id;
      });

      if (i > -1) {
        route.features[i] = payload;
      }

      state.route = { ...route };
    },

    setRouteLength(state, payload) {
      state.route.length = payload;
    },

    setCheckpoint(state, payload) {
      let route = state.route;

      route.features[payload.found] = payload.checkpoint;

      state.route = {};
      state.route = route;

      //console.log("######## setCheckpoint", state.route)
    },

    flushEditableDescription(state) {
      state.editableDescription = {};
      //console.log("#flushEditableDescription", state.editableDescription)
    },

    cancelDescriptionImageReplace(state) {
      let editableDescription = state.editableDescription;
      editableDescription.replace = false;
      state.editableDescription = {};
      state.editableDescription = editableDescription;
    },

    setDescriptionImageReplace(state, payload) {
      let editableDescription = state.editableDescription;
      editableDescription.replace = payload;
      state.editableDescription = {};
      state.editableDescription = editableDescription;
    },

    setEditRouteDescription(state, payload) {
      //console.log("######### payload", payload)
      state.editRouteDescription = payload;
    },

    setEditRouteGroup(state, payload) {
      state.editRouteGroup = payload;
    },

    mapMarkersToLeafletMarkers(state, payload) {
      state.markers = payload;
    },

    flushMovedMarkers(state) {
      state.movedMarkers = {};
    },

    flushSelectedRouteGroup(state) {
      (state.route.routegroup = undefined),
        (state.route.routegroupDisplayName = undefined);
    },

    flushSelectedNewRouteRouteGroup(state) {
      state.newRoute.routegroup = undefined;
    },

    setSelectedRouteGroup(state, payload) {
      //state.route.routegroup = state.routeGroups[payload].value;
      //state.route.routegroupDisplayName = state.routeGroups[payload].text

      let route = state.route;

      route.routegroup = payload.routegroup;
      route.routegroupDisplayName = payload.routegroupDisplayName;
      state.route = undefined;
      state.route = route;
    },

    setSelectedNewRouteRouteGroup(state, payload) {
      state.newRoute.routegroup = state.routeGroups[payload];
    },

    setUpdateLocation(state, payload) {
      state.updateLocation = payload;
      window.vm.$emit('toggleUpdateLocation', payload);
    },

    setMovedMarker(state, payload) {
      state.movedMarkers[payload.id] = payload.latlng;
    },

    setConfirmRouteDelete(state, payload) {
      state.confirmRouteDelete = payload;
    },

    setIsFetching(state, payload) {
      state.isFething = payload;
    },

    flushNewRoute(state) {
      delete state.newRoute.marker;
    },

    setIsDirty(state, payload) {
      state.route.isDirty = payload;
    },

    sortFeatures(state, payload) {
      state.route.features = [];
      state.route.features = payload;
    },

    setDisabled(state, payload) {
      state.route.disabled = payload;
    },

    setAccessible(state, payload) {
      state.route.accessible = payload;
    },

    setName(state, payload) {
      state.route.displayName = payload;
    },

    setOldNames(state, payload) {
      state.oldNames = payload;
    },

    cleanEditableFeature(state) {
      try {
        state.editableFeature.isDirty = false;
        state.editableFeature.properties.name = state.editableFeature.oldName;
      } catch (
        err
        // eslint-disable-next-line no-empty
      ) {
        //console.log('hep');
      }
    },

    setEditableFeatureName(state, payload) {
      //state.editableFeature.properties.name = payload;
      /*if (state.editableFeature.oldName != payload && state.editableFeature.isDirty !== true) {

                state.editableFeature.isDirty = true;
            } else if (state.editableFeature.oldName == payload && state.editableFeature.isDirty) {

                state.editableFeature.isDirty = false;
            }*/

      let editableFeature = state.editableFeature;
      editableFeature.properties.name = payload;
    },

    flushFeatureEditable(state) {
      let route = state.route;
      if (typeof route !== 'undefined') {
        try {
          route.features = route.features.map(f => {
            return { ...f, editable: false };
          });

          state.route = { ...route };
        } catch (
          err
          // eslint-disable-next-line no-empty
        ) {}
      }

      state.editableFeature = undefined;
    },

    setFeatureEditable(state, payload) {
      let route = state.route;
      //state.route = undefined;

      route.features[payload.i].editable = true;
      state.editableFeature = {
        ...route.features[payload.i],
        oldName: route.features[payload.i].properties.name
      };

      //state.editableFeature.oldName = state.oldNames[payload.id]

      //state.route = {...route};
    },

    setHasFinish(state, payload) {
      state.hasFinish = payload;
    },

    flushHighLighted(state) {
      let route = state.route;
      if (typeof route !== 'undefined' && typeof route.features !== 'undefined')
        route.features.map(f => {
          return { ...f, style: {} };
        });

      state.route = undefined;
      state.route = route;
    },

    flushConfirmDelete(state) {
      let route = state.route;
      route.features.forEach(f => {
        f.confirmDelete = false;
      });

      state.route = undefined;
      state.route = route;
    },

    setHighLighted(state, payload) {
      let route = state.route;
      state.route = undefined;

      route.features[payload].style = { 'font-weight': 'bold' };

      state.route = { ...route };
    },

    setConfirmDelete(state, payload) {
      let route = state.route;
      state.route = undefined;

      route.features[payload].confirmDelete = true;

      state.route = route;
    },

    replace(state, payload) {
      let i = payload.i;
      let route = payload.route;
      let routes = state.routes;
      state.routes = [];
      routes[i] = route;
      state.routes = routes;
    },

    setCreateFinishCheckpointAutomatically(state, payload) {
      state.newRoute.createFinishCheckpointAutomatically = payload;
    },

    index(state, payload) {
      state.routes = payload;
    },

    flushRoute(state) {
      state.route = undefined;
    },

    store(state, payload) {
      let routes = state.routes;
      state.payload = [];
      routes.push(payload);
      state.routes = routes;
    },

    /*setMarkerLeafletId(state, payload)
        {
            let markers = state.markers;
            markers[payload.i].leafletid = payload.leafletid;
            state.markers = markers;

        },*/

    setNewRouteMarker(state, payload) {
      state.newRoute['marker'] = payload;
    },

    setNewRouteDisplayName(state, payload) {
      state.newRoute.displayName = payload;
    },

    setSelectedMarker(state, payload) {
      //console.log("############## setSelectedMarker", payload)
      state.selectedMarker = payload;
    },

    setSelectedLeafletMarker(state, payload) {
      state.selectedLeafletMarker = payload;
    },

    setVisible(state, payload) {
      payload.indexes.forEach(i => {
        state.markers[i].visible = payload.visible;
      });
    },

    search(state, payload) {
      state.search = payload;
    },

    setZoom(state, payload) {
      state.zoom = payload;
    },

    setCenter(state, payload) {
      state.center = { ...payload };
    },

    features(state, payload) {
      let features = [];

      let route = state.routes.find(r => {
        return r._id == payload;
      });

      if (route) {
        features = route.features;
      }

      state.features = features;
    },

    setMarkers(state) {
      //console.log("########setMarkers", typeof state.routes === 'undefined')

      let markers = [];
      let focuspoints = {};
      let routegroups = [];

      /*if(typeof state.routes === 'array')
            {*/

      state.routes.forEach(r => {
        if (
          !routegroups.find(rg => {
            return rg.value == r.routegroup;
          })
        ) {
          let fp = r.focusPoint.coordinates[1] + r.focusPoint.coordinates[0];
          let count = 0;

          if (typeof focuspoints[fp] !== 'undefined') {
            count = focuspoints[fp] + 1;
          }

          r.visible = true;
          r.position = {
            lat: r.focusPoint.coordinates[1],
            lng: r.focusPoint.coordinates[0]
          };
          routegroups.push({
            text: r.routegroupDisplayName,
            value: r.routegroup
          });

          r.rotationAngle = count * 60;
          focuspoints[fp] = count;
          markers.push(r);
        }
      });
      //}

      state.routeGroups = [];
      state.routeGroups.push({
        value: undefined,
        text: 'New Group'
      });

      state.routeGroups = state.routeGroups.concat(routegroups);
      state.markers = markers;
    },

    matchingFocusPoints(state, payload) {
      state.matchingFocusPoints[payload.m._id] = payload.routes;
    },

    setRouteLayerGroupVisible(state, payload) {
      state.routeLayerGroupVisible = payload;
    },

    route(state, payload) {
      payload = {
        ...payload,
        leafletid: state.markers.find(m => m._id == payload._id).leafletid
      };

      state.route = payload;
    },

    setShowMatchingFocusPointsDialog(state, payload) {
      state.showMatchingFocusPointsDialog = payload;
    }
  },

  getters: {
    editMode(state) {
      return state.editMode;
    },

    feedback(state) {
      return state.feedback;
    },

    calculateLengthAutomatically(state) {
      return state.calculateLengthAutomatically;
    },

    editRouteView(state) {
      return state.editRouteView;
    },

    isUpdatingRouteGroup(state) {
      return state.isUpdatingRouteGroup;
    },

    routeLength(state) {
      let routeLength = 0;
      if (typeof state.route !== 'undefined') {
        routeLength = state.route.length;
      }

      return routeLength;
    },

    editableDescription(state) {
      return state.editableDescription;
    },

    editRouteDescription(state) {
      return state.editRouteDescription;
    },

    editRouteGroup(state) {
      return state.editRouteGroup;
    },

    canBeDetached(state) {
      let cbd = false;
      if (typeof state.route !== 'undefined') {
        cbd = state.route.canBeDetached;
      }

      return cbd;
    },

    updateLocation(state) {
      return state.updateLocation;
    },

    index(state) {
      return state.routes;
    },

    markers(state) {
      return state.markers;
    },

    zoom(state) {
      return state.zoom;
    },

    center(state) {
      return window.L.latLng(state.center.lat, state.center.lng);
    },

    selectedMarker(state) {
      return state.selectedMarker;
    },

    routeLayerGroupVisible(state) {
      return state.routeLayerGroupVisible;
    },

    route(state) {
      return state.route;
    },

    matchingFocusPoints(state) {
      return state.matchingFocusPoints;
    },

    showMatchingFocusPointsDialog(state) {
      return state.showMatchingFocusPointsDialog;
    },

    search(state) {
      return state.search;
    },

    selectedLeafletMarker(state) {
      return state.selectedLeafletMarker;
    },

    newRoute(state) {
      return state.newRoute;
    },

    hasFinish(state) {
      return state.hasFinish;
    },

    editableFeature(state) {
      return state.editableFeature;
    },

    isDirty(state) {
      let isDirty = false;
      if (typeof state.route !== 'undefined') {
        isDirty = state.route.isDirty;
      }

      return isDirty;
    },

    isFething(state) {
      return state.isFething;
    },

    confirmRouteDelete(state) {
      return state.confirmRouteDelete;
    },

    routeGroups(state) {
      let routeGroups = [];
      let temps = [];

      /*if(typeof state.routes === 'array')
            {*/

      state.routes.forEach(r => {
        if (
          !temps.find(t => {
            return t === r.routegroup;
          })
        ) {
          temps.push(r.routegroup);
          routeGroups.push({
            text: r.routegroupDisplayName,
            value: r.routegroup
          });
        }
      });
      //}

      return routeGroups;
    },

    routeGroupsEdit(state) {
      /*let groups = state.routeGroups;
            groups.shift();

            return groups;*/

      let routeGroups = [];
      let temps = [];

      /*if(typeof state.routes === 'array')
            {*/

      state.routes.forEach(r => {
        if (
          !temps.find(t => {
            return t === r.routegroup;
          })
        ) {
          temps.push(r.routegroup);
          routeGroups.push({
            text: r.routegroupDisplayName,
            value: r.routegroup
          });
        }
      });
      //}

      return routeGroups;
    }
  }
};
